import { useMemo } from 'react';

import useEstonia from '@/hooks/estonia';
import { useGoogleRegistrationABTest } from '@/modules/common';
import { useServer } from '@/modules/server/context/ServerEnvContext';
import { useCommonStore } from '@/store';

const AUTHBANNER_HEIGHT = 400;

const EE_LICENSE_BANNER_HEIGHT = 486;

const MOB_REGBANNER_WITH_OATH_HEIGHT = 1100;
const DESK_REGBANNER_WITH_OATH_HEIGHT = 720;

const MOB_REGBANNER_HEIGHT = 984;

export const useSliderHeight = () => {
  const { isMobileDevice } = useServer();

  const { isEstonia } = useEstonia();

  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const isGoogleRegAvailable = useGoogleRegistrationABTest();

  const height = useMemo(() => {
    if (isAuthenticated) {
      return AUTHBANNER_HEIGHT;
    } else if (isEstonia) {
      return EE_LICENSE_BANNER_HEIGHT;
    } else if (isGoogleRegAvailable) {
      return isMobileDevice
        ? MOB_REGBANNER_WITH_OATH_HEIGHT
        : DESK_REGBANNER_WITH_OATH_HEIGHT;
    }
    return isMobileDevice
      ? MOB_REGBANNER_HEIGHT
      : DESK_REGBANNER_WITH_OATH_HEIGHT;
  }, [isAuthenticated, isEstonia, isMobileDevice, isGoogleRegAvailable]);

  return height;
};
